import { render, staticRenderFns } from "./HelpButtonV2.vue?vue&type=template&id=af1d30bc&scoped=true"
import script from "./HelpButtonV2.vue?vue&type=script&lang=js"
export * from "./HelpButtonV2.vue?vue&type=script&lang=js"
import style0 from "./HelpButtonV2.vue?vue&type=style&index=0&id=af1d30bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d30bc",
  null
  
)

export default component.exports